import React from 'react'
import {willUseSharedState} from '@startlibs/core'

export const [useProviderInfo] = willUseSharedState()
